import * as types from './mutation-types'

const mutations = {
  [types.DIALOG_SHOW](state) {
    state.dialogShow = true
  },
  [types.DIALOG_HIDE](state) {
    state.dialogShow = false
  },
  // 创建用户弹窗显示
  [types.CREATE_USER_SHOW](state) {
    state.createUserShow = true
  },
  // 创建用户弹窗隐藏
  [types.CREATE_USER_HIDE](state) {
    state.createUserShow = false
  },
  // 用户信息弹窗显示
  [types.USER_SHOW](state) {
    state.userShow = true
  },
  // 用户信息弹窗隐藏
  [types.USER_HIDE](state) {
    state.userShow = false
  },
  // 用户列表弹窗显示
  [types.USER_LIST_SHOW](state) {
    state.userListShow = true
  },
  // 用户列表弹窗隐藏
  [types.USER_LIST_HIDE](state) {
    state.userListShow = false
  },
  // 通用列表弹窗显示
  [types.LIST_DIALOG_SHOW](state) {
    state.listDialogShow = true
  },
  // 通用列表弹窗隐藏
  [types.LIST_DIALOG_HIDE](state) {
    state.listDialogShow = false
  },
  // 创建用户组弹窗显示
  [types.CREATE_GROUP_SHOW](state) {
    state.createGroupShow = true
  },
  // 创建用户组弹窗隐藏
  [types.CREATE_GROUP_HIDE](state) {
    state.createGroupShow = false
  },
  // 用户组信息弹窗显示
  [types.GROUP_SHOW](state) {
    state.groupShow = true
  },
  // 用户组信息弹窗隐藏
  [types.GROUP_HIDE](state) {
    state.groupShow = false
  },
  // 用户组信息弹窗显示
  [types.AUTHORITY_SHOW](state) {
    state.authorityShow = true
  },
  // 用户组信息弹窗隐藏
  [types.AUTHORITY_HIDE](state) {
    state.authorityShow = false
  },
  // 用户组信息弹窗显示
  [types.SELECT_DIALOG_SHOW](state) {
    state.selectDialogShow = true
  },
  // 用户组信息弹窗隐藏
  [types.SELECT_DIALOG_HIDE](state) {
    state.selectDialogShow = false
  },
  // 用户组信息弹窗显示
  [types.SELECT_TYPE_DIALOG_SHOW](state) {
    state.selectTypeDialogShow = true
  },
  // 用户组信息弹窗隐藏
  [types.SELECT_TYPE_DIALOG_HIDE](state) {
    state.selectTypeDialogShow = false
  },
  // properties 左侧树右键属性
  [types.PROPERTIES_DIALOG_SHOW](state) {
    state.propertiesDialogShow = true
  },
  [types.PROPERTIES_DIALOG_HIDE](state) {
    state.propertiesDialogShow = false
  },
  // 动态图 onlineChart右键属性
  [types.ONLINECHART_PROPERTIES_DIALOG_SHOW](state) {
    state.onlineChartDialogShow = true
  },
  [types.ONLINECHART_PROPERTIES_DIALOG_HIDE](state) {
    state.onlineChartDialogShow = false
  },
  // 动态图-曲线图趋势记录 onlineChart右键属性
  [types.ONLINECHART_PROPERTIES_TREND_SHOW](state) {
    state.onlineChartTrendShow = true
  },
  [types.ONLINECHART_PROPERTIES_TREND_HIDE](state) {
    state.onlineChartTrendShow = false
  },
  // 图形化动态属性
  [types.GRAPHI_CALLY_SHOW](state) {
    state.graphiCallyShow = true
  },
  [types.GRAPHI_CALLY_HIDE](state) {
    state.graphiCallyShow = false
  },
  // 记事本
  [types.NOTE_BOOK_SHOW](state) {
    state.noteBookShow = true
  },
  [types.NOTE_BOOK_HIDE](state) {
    state.noteBookShow = false
  },
  // 数据接口
  [types.DATA_INTERFACE_SHOW](state) {
    state.dataInterfaceShow = true
  },
  [types.DATA_INTERFACE_HIDE](state) {
    state.dataInterfaceShow = false
  },
  // TOPIC
  [types.TOPIC_SHOW](state) {
    state.topicShow = true
  },
  [types.TOPIC_HIDE](state) {
    state.topicShow = false
  },
  // door
  [types.DOOR_SHOW](state) {
    state.doorShow = true
  },
  [types.DOOR_HIDE](state) {
    state.doorShow = false
  },
  // trendLogs
  [types.TREND_LOGS_SHOW](state) {
    state.trendLogsShow = true
  },
  [types.TREND_LOGS_HIDE](state) {
    state.trendLogsShow = false
  },
  // 趋势日志数据
  [types.TREND_LOGS_SHOW](state) {
    state.trendLogsShow = true
  },
  [types.TREND_LOGS_HIDE](state) {
    state.trendLogsShow = false
  },
  // 用户管理
  [types.USERS_SHOW](state) {
    state.usersShow = true
  },
  [types.USERS_HIDE](state) {
    state.usersShow = false
  },
  // 计算工具
  [types.COUNT_BOOK_SHOW](state) {
    state.countBookShow = true
  },
  [types.COUNT_BOOK_HIDE](state) {
    state.countBookShow = false
  },
  // 趋势日志
  [types.TREND_JOURNAL_SHOW](state) {
    state.trendJournalShow = true
  },
  [types.TREND_JOURNAL_HIDE](state) {
    state.trendJournalShow = false
  },
  // 趋势日志导出
  [types.TREND_JOURNAL_EXPRESS_SHOW](state) {
    state.trendJournalExpressShow = true
  },
  [types.TREND_JOURNAL_EXPRESS_HIDE](state) {
    state.trendJournalExpressShow = false
  },
  // 报警接收者 alarmChart右键属性
  [types.ALARMCHART_PROPERTIES_DIALOG_SHOW](state) {
    state.alarmChartDialogShow = true
  },
  [types.ALARMCHART_PROPERTIES_DIALOG_HIDE](state) {
    state.alarmChartDialogShow = false
  },
  // change-of-state右键属性
  [types.CHANGE_OF_STATE_SHOW](state) {
    state.changeOfStateShow = true
  },
  [types.CHANGE_OF_STATE_HIDE](state) {
    state.changeOfStateShow = false
  },
  // alarmControl右键属性
  [types.ALARM_CONTROL_SHOW](state) {
    state.alarmControlShow = true
  },
  [types.ALARM_CONTROL_HIDE](state) {
    state.alarmControlShow = false
  },
  // 报警用户组右键属性
  [types.GROUP_ALARM_SHOW](state) {
    state.groupAlarmShow = true
  },
  [types.GROUP_ALARM_HIDE](state) {
    state.groupAlarmShow = false
  },
  // 设备对象属性
  [types.DEVICE_DIALOG_SHOW](state) {
    state.deviceDialogShow = true
  },
  [types.DEVICE_DIALOG_HIDE](state) {
    state.deviceDialogShow = false
  },
  // 程序的下载
  [types.ORDER_DIALOG_SHOW](state) {
    state.orderDialogShow = true
  },
  [types.ORDER_DIALOG_HIDE](state) {
    state.orderDialogShow = false
  },
  // 设备列表对象属性
  [types.DEVICE_LIST_DIALOG_SHOW](state) {
    state.deviceListDialogShow = true
  },
  [types.DEVICE_LIST_DIALOG_HIDE](state) {
    state.deviceListDialogShow = false
  },
  // 树刷新控制
  [types.NEED_RELOAD_TREE](state) {
    state.isReloadTree = true
  },
  [types.DONOT_NEED_RELOAD_TREE](state) {
    state.isReloadTree = false
  },
  // 点位控制
  [types.POINT_SHOW](state) {
    state.pointShow = true
  },
  [types.POINT_HIDE](state) {
    state.pointShow = false
  },
  // 添加folder
  [types.FOLDER_SHOW](state) {
    state.addFolderDialog = true
  },
  [types.FOLDER_HIDE](state) {
    state.addFolderDialog = false
  },
  // 添加folder工具
  [types.FOLDER_DESGIN_SHOW](state) {
    state.addFolderDesginDialog = true
  },
  [types.FOLDER_DESGIN_HIDE](state) {
    state.addFolderDesginDialog = false
  },
  // 时间表控制
  [types.TIME_CHART_SHOW](state) {
    state.timeChartShow = true
  },
  [types.TIME_CHART_HIDE](state) {
    state.timeChartShow = false
  },
  // 时间表批量控制
  [types.TIME_CHART_BATCH_SHOW](state) {
    state.timeChartBatchShow = true
  },
  [types.TIME_CHART_BATCH_HIDE](state) {
    state.timeChartBatchShow = false
  },

  // 值时间表批量控制
  [types.TIME_CHART_VALUE_SHOW](state) {
    state.timeChartValueShow = true
  },
  [types.TIME_CHART_VALUE_HIDE](state) {
    state.timeChartValueShow = false
  },
  // 能耗资源控制
  [types.ENERGY_DIALOG_SHOW](state) {
    state.energyDialogShow = true
  },
  [types.ENERGY_DIALOG_HIDE](state) {
    state.energyDialogShow = false
  },

  // 能耗资源控制
  [types.ENERGY_BAR_SHOW](state) {
    state.energyBarShow = true
  },
  [types.ENERGY_BAR_HIDE](state) {
    state.energyBarShow = false
  },

  // 能耗批量统计
  [types.ENERGY_STATISTICS_SHOW](state) {
    state.energyStatisticsShow = true
  },
  [types.ENERGY_STATISTICS_HIDE](state) {
    state.energyStatisticsShow = false
  },

  // 盘管检查
  [types.COIL_DIALOG_SHOW](state) {
    state.coilDialogShow = true
  },
  [types.COIL_DIALOG_HIDE](state) {
    state.coilDialogShow = false
  },
  // 创建规则
  [types.RULE_DIALOG_SHOW](state) {
    state.ruleDialogShow = true
  },
  [types.RULE_DIALOG_HIDE](state) {
    state.ruleDialogShow = false
  },
  // 创建方波
  [types.SQUARE_DIALOG_SHOW](state) {
    state.squareDialogShow = true
  },
  [types.SQUARE_DIALOG_HIDE](state) {
    state.squareDialogShow = false
  },
  // 假期计划表
  [types.HOLIDAY_SHOW](state) {
    state.holidayShow = true
  },
  [types.HOLIDAY_HIDE](state) {
    state.holidayShow = false
  },
  // 点位窗口打开
  [types.OPEN_POINT_DIALOG](state, payload) {
    state.pointData = payload
  },
  // 搜索界面控制

  [types.SEARCH_DIALOG_SHOW](state) {
    state.searchDialogShow = true
  },
  [types.SEARCH_DIALOG_HIDE](state) {
    state.searchDialogShow = false
  },

  // 对象传输界面控制
  [types.OBJECT_TRANSFER_SHOW](state) {
    state.objectTransferShow = true
  },
  [types.OBJECT_TRANSFER_HIDE](state) {
    state.objectTransferShow = false
  },

  // 时间事件对象界面控制
  [types.TIME_EVENT_OBJECT_SHOW](state) {
    state.timeEventObjectShow = true
  },
  [types.TIME_EVENT_OBJECT_HIDE](state) {
    state.timeEventObjectShow = false
  },

  // 时间事件列表界面控制
  [types.TIME_EVENT_LIST_SHOW](state) {
    state.timeEventListShow = true
  },
  [types.TIME_EVENT_LIST_HIDE](state) {
    state.timeEventListShow = false
  },
  [types.STATISTICS_MODULE_SHOW](state) {
    state.statisticsModuleShow = true
  },
  [types.STATISTICS_MODULE_HIDE](state) {
    state.statisticsModuleShow = false
  },
  // 标签管理界面控制（statisticModule）
  [types.LABEL_MANAGE_SHOW](state) {
    state.labelManageShow = true
  },
  [types.LABEL_MANAGE_HIDE](state) {
    state.labelManageShow = false
  },
  // 标签管理界面控制（EHI）
  [types.EHI_LABEL_MANAGE_SHOW](state) {
    state.ehiLabelManageShow = true
  },
  [types.EHI_LABEL_MANAGE_HIDE](state) {
    state.ehiLabelManageShow = false
  },
  // 环境健康指数界面控制
  [types.EHI_SHOW](state) {
    state.EHIShow = true
  },
  [types.EHI_HIDE](state) {
    state.EHIShow = false
  },
  // 海康摄像头界面控制
  [types.HKVIDEO_SHOW](state) {
    state.hkvideoShow = true
  },
  [types.HKVIDEO_HIDE](state) {
    state.hkvideoShow = false
  },

  // 值计算
  [types.VALUE_CALCULATION_SHOW](state) {
    state.valueCalculationShow = true
  },
  [types.VALUE_CALCULATION_HIDE](state) {
    state.valueCalculationShow = false
  },
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js